import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./css/hero.css";
import image from "../images/ghada.jpg";

function Hero() {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  return (
    <div className="all-hero">

         <div className="hero-image">
            <img src={image} width={400} />
        </div>
       
     
      <div className="hero-content" data-aos="fade-up">
        <h1>غادة سعداوي</h1>
        <p>
        علاج صعوبات واضطرابات التعلم  
مشاكل النطق والكلام مشاكل التركيز والانتباه  
متابعة تربوية نفسية للاطفال والمراهقين و العائلة   مختصة في العلاج السلوكي والمعرفي  لجميع الفءات العمرية
        </p>
        <button className="read-more-btn">أقرأ المزيد</button>
      </div>

      
    </div>
  );
}

export default Hero;
